import { useEffect } from 'react';

const useEscapeKey = (onEscape) => {
  useEffect(() => {
    const handleEsc = (e) => {
      if (e.key === 'Escape') {
        if (onEscape) {
          onEscape();
        }
      }
    };

    document.addEventListener('keydown', handleEsc);
    return () => {
      document.removeEventListener('keydown', handleEsc);
    };
  }, [onEscape]);
};

export { useEscapeKey };
export default useEscapeKey;
